import { useRef, useMemo } from 'react';

import { Tooltip, TooltipProps, Box, rem } from '@vimeo/bokeh';

interface IBokehTooltipProps extends Partial<TooltipProps> {
  inPopover?: boolean;
}

export function BokehTooltip({
  isOpen,
  placement = 'top',
  label,
  children,
  gutter = 8,
  width,
  maxWidth = rem(300),
  fontSize = 'header-xs',
  hasArrow = false,
  shouldWrapChildren = true,
  inPopover = false,
  offset,
  modifiers,
  ...rest
}: IBokehTooltipProps) {
  const toolTipRef = useRef(null);

  const defaultProps = useMemo(() => {
    return {
      isOpen,
      placement,
      label,
      shouldWrapChildren,
      fontSize,
      gutter,
      offset,
      hasArrow,
      modifiers,
      maxWidth,
      width,
    };
  }, [
    width,
    maxWidth,
    isOpen,
    fontSize,
    gutter,
    offset,
    hasArrow,
    label,
    placement,
    shouldWrapChildren,
    modifiers,
  ]);

  return (
    <>
      {inPopover ? (
        <Box ref={toolTipRef}>
          <Tooltip portalProps={{ containerRef: toolTipRef }} {...defaultProps} {...rest}>
            {children}
          </Tooltip>
        </Box>
      ) : (
        <Tooltip {...defaultProps} {...rest}>
          {children}
        </Tooltip>
      )}
    </>
  );
}
